import { FC } from "react"
import { SimCardType2 } from "@phonero/common-graphql/types"
import { SimCardTypes } from "./components/SimCard/SimCardTypes"

export const SubscriptionDataSimCardPage: FC<any> = () => {
  return <SimCardTypes simCardType={SimCardType2.Datacard} />
}

export default SubscriptionDataSimCardPage
